import bookmark from "./Icons/bookmark.svg";
import comments from "./Icons/comments.svg";
import follower_gain from "./Icons/follower_gain.svg";
import follower_lost from "./Icons/follower_loss.svg";
import likes from "./Icons/likes.svg";
import link from "./Icons/link.svg";
import profile from "./Icons/profile.svg";
import reach from "./Icons/reach.svg";
import send from "./Icons/send.svg";
import image from "./Icons/standard_post.svg";
import star from "./Icons/Star.svg";
import story from "./Icons/instagramStory.svg";
import view from "./Icons/view.svg";
import refresh from "./Icons/refresh.svg";
import chart from "./Icons/chart.svg";
import close from "./Icons/close.svg";
import calender from "./Icons/calendar.svg";
import carousel_album from "./Icons/carousel.svg";
import video from "./Icons/video.svg";
import save from "./Icons/save.svg";
import newFollowers from "./Icons/newFollowers.svg";
import engagement from "./Icons/engagement.svg";
import impression from "./Icons/impression.svg";
import followerChange from "./Icons/followerChange.svg";
import websiteClick from "./Icons/websitesClicks.svg";
import profileVisit from "./Icons/profileVisits.svg";
import bestTimetoPost from "./Icons/bestTimetoPost.svg";
import brain from "./Icons/brain.svg";
import totalFollowers from "./Icons/totalFollowers.svg";
import insights from "./Icons/insights.svg";
import info from "./Icons/info.svg";
import share from "./Icons/share.svg";
import text from "./Icons/text.svg";
import emailContact from "./Icons/emailContact.svg";
import postInsight from "./Icons/postInsight.svg";
import geography from "./Icons/geography.svg";
import location from "./Icons/location.svg";
import timezone from "./Icons/timezone.svg";
import age from "./Icons/age.svg";
import pageLike from "./Icons/pageLike.svg";
import postClick from "./Icons/postClick.svg";
import buttonClick from "./Icons/buttonClick.svg";
import cellClick from "./Icons/cellClick.svg";
import pageDislike from "./Icons/pageDislike.svg";
import pageDirection from "./Icons/pageDirection.svg";
import pageCheckin from "./Icons/pageCheckin.svg";
import engagedFollower from "./Icons/engagedFollower.svg";
import reels from "./Icons/ig-reel.svg";
import plays from "./Icons/plays.svg";
import interactions from "./Icons/interactions.svg";
import closeRounded from "./Icons/close-rounded.svg";
import downArrow from "./Icons/downArrow.svg";
import upArrow from "./Icons/upArrow.svg";
import caretDown from "./Icons/caretDown.svg";
import openInBrowser from "./Icons/openInBrowser.svg";
import brandIcon from "./Icons/brand-icon.svg";
import warningAlert from "./Icons/warningAlert.svg";
import totalActionsOutline from "./Icons/totalActionsOutline.svg";
import clock from "./Icons/clock.svg";
import likesOutline from "./Icons/likesOutline.svg";
import commentsOutline from "./Icons/commentsOutline.svg";
import shareOutline from "./Icons/shareOutline.svg";
import eyeLight from "./Icons/eyeLight.svg";
import reachLight from "./Icons/reachLight.svg";
import clickLight from "./Icons/clickLight.svg";
import likesLight from "./Icons/likesLight.svg";
import commentLight from "./Icons/commentLight.svg";
import shareLight from "./Icons/shareLight.svg";
import labelTag from "./Icons/labelTag.svg";
import loading1 from "./Icons/loading-1.svg";
import arrowRight from "./Icons/arrow-right.svg";
import facebook from "./Icons/facebook.svg";
import instagram from "./Icons/instagram.svg";
import linkedin from "./Icons/linkedin.svg";
import googlemybusiness from "./Icons/googlemybusiness.svg";
import tiktok from "./Icons/tiktok.svg";

const icons = {
  bookmark,
  comments,
  follower_gain,
  follower_lost,
  likes,
  link,
  profile,
  reach,
  send,
  image,
  star,
  story,
  view,
  refresh,
  chart,
  close,
  calender,
  carousel_album,
  video,
  save,
  newFollowers,
  engagement,
  impression,
  followerChange,
  websiteClick,
  profileVisit,
  bestTimetoPost,
  brain,
  totalFollowers,
  insights,
  info,
  share,
  text,
  album: carousel_album,
  emailContact,
  postInsight,
  geography,
  location,
  timezone,
  age,
  pageLike,
  postClick,
  buttonClick,
  cellClick,
  pageDislike,
  pageDirection,
  pageCheckin,
  engagedFollower,
  reels,
  plays,
  interactions,
  closeRounded,
  downArrow,
  upArrow,
  caretDown,
  openInBrowser,
  brandIcon,
  warningAlert,
  totalActionsOutline,
  likesOutline,
  commentsOutline,
  shareOutline,
  eyeLight,
  reachLight,
  clickLight,
  likesLight,
  commentLight,
  shareLight,
  labelTag,
  loading1,
  arrowRight,
  instagram,
  facebook,
  linkedin,
  googlemybusiness,
  tiktok,
};

export { clock };

export default icons;
